import React from 'react';
import { Card, Placeholder } from 'react-bootstrap';

const NotesSkeleton = () => {
  return (
    <div className="notes-feed">
      {[...Array(3)].map((_, index) => (
        <Card key={index} className="mb-3">
          <Card.Body>
            <div className="d-flex">
              <div className="me-3">
                <Placeholder animation="glow">
                  <Placeholder style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                </Placeholder>
              </div>
              <div style={{ flex: 1 }}>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={4} />
                </Placeholder>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={8} />
                  <Placeholder xs={6} />
                </Placeholder>
              </div>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default NotesSkeleton;
